/* eslint-disable react-refresh/only-export-components */
import type { Person } from '@/store/people/types';
import type { Reminder } from '@/store/reminders/types';
import { createContext, useContext, useState, type ReactNode } from 'react';
import { ReminderModal } from './modal';

export interface ReminderModalState {
  open: boolean;
  setOpen: (value: boolean) => void;
  currentReminder: Reminder | null;
  setCurrentReminder: (value: Reminder | null) => void;
  currentPerson: Person | null;
  setCurrentPerson: (value: Person | null) => void;
}

const ReminderModalContext = createContext({} as ReminderModalState);

export function ReminderModalProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [currentReminder, setCurrentReminder] = useState<Reminder | null>(null);
  const [currentPerson, setCurrentPerson] = useState<Person | null>(null);
  const state: ReminderModalState = {
    open,
    setOpen,
    currentReminder,
    setCurrentReminder,
    currentPerson,
    setCurrentPerson,
  };

  return (
    <ReminderModalContext.Provider value={state}>
      <>
        <ReminderModal
          isOpen={open}
          onOpenChange={setOpen}
          target={currentPerson}
          reminder={currentReminder}
        />
        {children}
      </>
    </ReminderModalContext.Provider>
  );
}

export function useReminderModal() {
  return useContext(ReminderModalContext);
}
